<template>
  <div class="Header">
    <div class="nav"></div>
    <mt-header title="添加提醒" class="remind-head" fixed>
      <router-link to="/reminder" slot="left">
        <img src="../assets/reminder/left.png" />
        <!-- <mt-button icon="back">返回</mt-button> -->
      </router-link>
      <!-- <mt-button icon="more" slot="right"></mt-button> -->
    </mt-header>
  </div>
</template>

<script>
import { Header } from "mint-ui";

// Vue.component(Switch.name, Switch)

export default {
  name: "Header",
  components: {
    "mt-header": Header
  },
  data() {
    return {
      _title: "添加提醒"
    };
  }
};
</script>

<style scoped>
.mint-header .mint-header-title {
  opacity: 0.9;
  font-size: 20px;
  font-family: HarmonyOS_Sans_Medium;
  font-weight: 400;
  color: #1c3f7d;
  line-height: 29px;
  text-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
}
.remind-head {
  background: white;
  border-bottom: solid 1px #e1e1e1;
  min-height: 3rem;
}

.nav {
  background: #fff;
  height: 44px;
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue